<div class="bg-white rounded-xl border border-gray-200 shadow-sm">
  <div class="px-5 py-4 border-b border-gray-100">
    <h3 class="text-sm font-semibold text-gray-900 flex items-center gap-2">
      <mat-icon class="!text-[18px] !w-[18px] !h-[18px] text-primary-600">fact_check</mat-icon>
      Review Progress
    </h3>
  </div>

  <div class="p-5">
    <div *ngFor="let s of workflow.steps; let last = last">
      <div class="flex items-start gap-3">
        <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center" [ngClass]="stepColor(s.status)">
          <mat-icon class="!text-[18px] !w-[18px] !h-[18px]">{{ stepIcon(s.status) }}</mat-icon>
        </div>

        <div class="flex-1 min-w-0">
          <div class="flex items-center justify-between gap-2 flex-wrap">
            <span class="text-sm font-medium text-gray-900">{{ s.role }}</span>
            <span class="inline-flex px-2 py-0.5 text-[11px] font-semibold rounded-full border" [ngClass]="chipColor(s.status)">
              {{ s.status | titlecase }}
            </span>
          </div>

          <div *ngIf="s.comment" class="mt-1.5 flex items-start gap-1.5 text-xs text-gray-600 bg-amber-50 border border-amber-100 rounded-lg px-2.5 py-1.5">
            <mat-icon class="!text-[14px] !w-3.5 !h-3.5 text-amber-500 mt-0.5 flex-shrink-0">comment</mat-icon>
            <span>{{ s.comment }}</span>
          </div>

          <div *ngIf="s.decisionAt" class="mt-1 text-[11px] text-gray-400">
            {{ s.decisionAt | date: 'MMM d, y' }}
          </div>
        </div>
      </div>

      <div *ngIf="!last" class="ml-4 my-1.5 w-px h-5" [ngClass]="connectorColor(s.status)"></div>
    </div>

    <div class="mt-4 pt-3 border-t border-gray-100">
      <span class="text-xs font-medium" [ngClass]="{
        'text-green-700': workflow.overallStatus === EStatus.FINALLY_APPROVED,
        'text-red-700': workflow.overallStatus === EStatus.FINALLY_REJECTED,
        'text-gray-600': workflow.overallStatus !== EStatus.FINALLY_APPROVED && workflow.overallStatus !== EStatus.FINALLY_REJECTED
      }">
        {{ overallLabel }}
      </span>
    </div>
  </div>
</div>
